import React from 'react';
import './ElevationPage.css';
import useScrollToTop from '../components/useScrollToTop'; // Create ElevationPage.css
import ReusableLanding from '../components/ReusableLanding';
import FAQ from '../components/FAQ';
import landimg from '../img/elveation_landing.avif';
import image1 from '../img/elevation_img_1.avif';
import image2 from '../img/elevation_img_2.avif';
import image3 from '../img/elevation_img_3.avif';
import image4 from '../img/elevation_img_4.avif';
import image5 from '../img/elevation_img_5.avif';
import image6 from '../img/elevation_img_6.avif';
import image7 from '../img/elevation_img_7.avif';
import image8 from '../img/elevation_img_8.avif';
import image9 from '../img/elevation_img_9.avif';
import image10 from '../img/elevation_img_10.avif';
import image11 from '../img/elevation_img_11.avif';
import image12 from '../img/elevation_img_12.avif';
import image13 from '../img/elevation_img_13.avif';
import image14 from '../img/elevation_img_14.avif';
import image15 from '../img/elevation_img_15.avif';
import image16 from '../img/elevation_img_16.avif';
import image18 from '../img/elevation_img_17.avif';
import image19 from '../img/elevation_img_18.avif';
import image20 from '../img/elevation_img_19.avif';
import image21 from '../img/elevation_img_20.avif';
import image22 from '../img/elevation_img_21.avif';
import image23 from '../img/elevation_img_22.avif';
import image24 from '../img/elevation_img_23.avif';
import image25 from '../img/elevation_img_24.avif';
import image26 from '../img/elevation_img_25.avif';
import image27 from '../img/elevation_img_26.avif';
import image28 from '../img/elevation_img_27.avif';
import image29 from '../img/elevation_img_28.avif';
import image30 from '../img/elevation_img_29.avif';
import elevationFAQData from '../components/ElevationFAQData';
import InquiryForm from '../components/InquiryForm';
import ServiceFeatures from '../components/ServiceFeatures';
import { FaSyncAlt, FaComments,FaCheckCircle } from 'react-icons/fa';

const ElevationPage = () => {
useScrollToTop();
const elevations = [
     {
    "id": 1,
    "title": "Modern Home",
    "image": image16,
    "description": "Striking modern front elevation showcasing clean lines, large windows, and contemporary architectural details."
  },
  {
    "id": 2,
    "title": "Two-Story Design",
    "image": image18,
    "description": "Elegant two-story front elevation emphasizing structural design, material choices, and balanced aesthetics."
  },
  {
    "id": 3,
    "title": "Two-Story Parking",
    "image": image19,
    "description": "Practical two-story house side elevation featuring integrated car parking and a functional layout."
  },
  {
    "id": 4,
    "title": "Dual House Front",
    "image": image20,
    "description": "Detailed front elevation of a two-unit residential building with intricate design and quality finishes."
  },
  {
    "id": 5,
    "title": "Two-Story Rear",
    "image": image21,
    "description": "Detailed rear elevation of a two-story house highlighting architectural design and material consistency."
  },
  {
    "id": 6,
    "title": "Three-Story Luxury",
    "image": image22,
    "description": "Detailed elevation of a luxurious three-story house showcasing intricate design and high-end finishes."
  },
  {
    "id": 7,
    "title": "House with Shop",
    "image": image23,
    "description": "Detailed front elevation of a two-story house integrated with a ground-floor shop, displaying a mixed-use design."
  },
  {
    "id": 8,
    "title": "Luxury Front",
    "image": image24,
    "description": "Detailed side elevation of a luxury house exhibiting sophisticated design elements and premium materials."
  },
  {
    "id": 9,
    "title": "Luxury Apartment",
    "image": image25,
    "description": "Detailed elevation of a luxury apartment complex showcasing intricate design and high-quality finishes."
  },
  {
    "id": 10,
    "title": "Two-Story Rear",
    "image": image26,
    "description": "Detailed rear elevation of a house illustrating architectural details and material applications."
  },
  {
    "id": 11,
    "title": "Luxury Mall",
    "image": image27,
    "description": "Detailed elevation of a luxury mall complex presenting modern architectural design and high-quality construction."
  },
  {
    "id": 12,
    "title": "Luxury Complex",
    "image": image28,
    "description": "Detailed elevation of a luxury apartment complex featuring contemporary design and premium finishes."
  },
  {
    "id": 13,
    "title": "Luxury Complex",
    "image": image29,
    "description": "Detailed elevation of a luxury apartment complex highlighting modern architecture and high-end materials."
  },
  {
    "id": 14,
    "title": "Apartment Complex",
    "image": image30,
    "description": "Detailed elevation of an apartment complex showcasing its architectural style and design features."
  },
  {
    "id": 16,
    "title": "Three-Story Front",
    "image": image1,
    "description": "Modern three-story residential building front elevation with prominent balconies and contemporary facade design."
  },
  {
    "id": 17,
    "title": "Three-Story Rear",
    "image": image2,
    "description": "Detailed rear elevation of a three-story apartment building showcasing architectural details and material choices."
  },
  {
    "id": 18,
    "title": "Contemporary House",
    "image": image3,
    "description": "Front elevation of a contemporary house featuring a distinctive sloped roof and unique architectural elements."
  },
  {
    "id": 19,
    "title": "Brick Building",
    "image": image4,
    "description": "Front elevation of a traditional brick building with classic detailing and inviting balconies."
  },
  {
    "id": 20,
    "title": "Residential Balconies",
    "image": image5,
    "description": "Front elevation of a residential building emphasizing spacious balconies and outdoor living areas."
  },
  {
    "id": 21,
    "title": "Townhouse Complex",
    "image": image6,
    "description": "Detailed elevation of a townhouse complex illustrating individual unit designs and communal spaces."
  },
  {
    "id": 22,
    "title": "Two-Story Home",
    "image": image7,
    "description": "Detailed elevation of a two-story home showcasing thoughtful designs and efficient space utilization."
  },
  {
    "id": 23,
    "title": "Parking Building",
    "image": image8,
    "description": "Elevation of a charming building with integrated car parking and traditional architectural features."
  },
  {
    "id": 24,
    "title": "Open Design",
    "image": image9,
    "description": "Side elevation of a house with an open and functional design, constructed with robust materials."
  },
  {
    "id": 25,
    "title": "Two-Story Parking",
    "image": image10,
    "description": "Rear elevation of a two-story building with designated car parking areas."
  },
  {
    "id": 26,
    "title": "Modern Outlook",
    "image": image11,
    "description": "Elevation of a home presenting a sleek and modern architectural style."
  },
  {
    "id": 27,
    "title": "Cultural Center",
    "image": image12,
    "description": "Detailed elevation of a cultural center distinguished by unique architectural forms and diverse materials."
  },
  {
    "id": 28,
    "title": "Suburban Home",
    "image": image13,
    "description": "Elevation of a suburban home featuring an attached garage and landscaped front yard."
  },
  {
    "id": 29,
    "title": "Three-Story Building",
    "image": image14,
    "description": "Front elevation of a three-story building showcasing its architectural design and facade details."
  },
  {
    "id": 30,
    "title": "Hospitality Building",
    "image": image15,
    "description": "Rear elevation of a hospitality building with visible amenities such as pools and terraces."
  }
  ];

const featuresData = [
    {
      icon: <FaSyncAlt />,
      text: 'Multiple design revisions',
    },
    {
      icon: <FaComments />,
      text: 'Free consultation with experts',
    },
    {
      icon: <FaCheckCircle />,
      text: '100% satisfaction guarantee',
    },
];

 return (
    <>
      <ReusableLanding
        imageUrl={landimg}
        title="Architectural Elevations: Visualize Your Home's Exterior"
        description="Explore detailed elevation drawings showcasing the exterior design and architectural features of our custom home projects."
      />
      <div className="elevation-page">
        <h1>House Elevation Designs - 3D Front Elevation Designs</h1>
        <div className="elevation-description">
          <p>
            3D House elevation designs can help visualize the proposed appearance of the exterior view and design of the house from any side e.g. front, back, corner or any other side. The main purpose of the building elevation design is to help you visualize the finished appearance of the exterior design of a building from a particular side or corner.
          </p>
          <p>
            Front house elevation design can show you the appearance of the building from the front side. Similarly, back elevation design of the building can show the finished appearance of the building from the back side. 3D Building elevation designs can be created for all sides and corners of the building, including day view and night view of the building.
          </p>
        </div>
        <div className="elevation-grid">
          {elevations.map((elevation) => (
            <div className="elevation-card" key={elevation.id}>
              <img src={elevation.image} alt={elevation.title} className="elevation-image" loading="lazy"/>
              <div className="elevation-details">
                <h2>{elevation.title}</h2>
                <p>{elevation.description}</p>
              </div>
            </div>
          ))}
        </div>
  
        <div className="elevation-construction">
          <div className="elevation-content">
            <h2>Architectural Elevations: Building Your Vision</h2>
            <p>
              Architectural elevations are orthographic projections that show the exterior
              sides of a building. They provide a clear view of the building's facade,
              including its height, width, and architectural features.
            </p>
  
            <h3>Why Elevations Are Important</h3>
            <ul>
              <li>
                <strong>Visual Representation:</strong> Elevations help visualize the final
                appearance of the building.
              </li>
              <li>
                <strong>Construction Guidance:</strong> They provide precise measurements
                and details for builders.
              </li>
              <li>
                <strong>Design Communication:</strong> Elevations facilitate communication
                between designers, clients, and contractors.
              </li>
              <li>
                <strong>Aesthetic Planning:</strong> they help to plan the look and feel of the outside of the home.
              </li>
            </ul>
  
            <h3>Our Elevation Design Services</h3>
            <p>
              We create detailed and accurate elevation drawings, including:
            </p>
            <ul>
              <li>Front elevations</li>
              <li>Rear elevations</li>
              <li>Side elevations</li>
              <li>3D elevation renderings</li>
              <li>Day and night views</li>
            </ul>
  
            <div className="elevation-examples">
              <h3>Elevation Examples</h3>
              <div className="elevation-image-container">
                <img src={image18} alt="Front Elevation Example" loading="lazy"/>
                <img src={image24} alt="Side Elevation Example" loading="lazy"/>
                <img src={image30} alt="3D Elevation Example" loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
  
        <InquiryForm />
        <FAQ faqData={elevationFAQData} />
        <ServiceFeatures features={featuresData} />
      </div>
    </>
  );
};

export default ElevationPage;